<template>
  <ul :class="[ 'icon-list', item.classes ]">
    <li
      v-for="(line, index) in item.items"
      :key="index"
    >
      <span
        v-if="line.icon"
        :class="`icon icon-${line.icon}`"
      ></span>
      <p
        :class="line.classes"
        v-html="line.html"
      ></p>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'NodeIconList',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
}
</script>
